import { useSite } from '../context/SiteContext';
import { curriculum } from '../data/course';
import { toBn } from '../lib/utils';
import { taka } from '../lib/price';
import { CheckIcon, ExcelTile } from './Icons';

export default function Curriculum() {
  const { course } = useSite();

  return (
    <section id="curriculum" className="py-20">
      <div className="container-x">
        <div className="mx-auto max-w-2xl text-center">
          <span className="eyebrow">কোর্স কারিকুলাম</span>
          <h2 className="section-title">{toBn(course.totalClasses)}টি ক্লাসে যা যা শিখবেন</h2>
          <p className="mt-4 text-lg text-slate-600">
            অফিসে সবচেয়ে বেশি যা লাগে, শুধু সেগুলোই — একদম বেসিক থেকে শুরু করে ফর্মুলা, VLOOKUP, চার্ট আর Pivot Table পর্যন্ত, ধাপে ধাপে।
          </p>
        </div>

        <div className="mt-12 grid gap-5 sm:grid-cols-2 lg:grid-cols-4">
          {curriculum.map((c, i) => (
            <article key={c.title} className="rounded-2xl bg-white p-6 shadow-sm ring-1 ring-slate-200 transition hover:-translate-y-1 hover:shadow-lg hover:ring-excel-500">
              <div className="flex items-center justify-between">
                <ExcelTile />
                <span className="rounded-full bg-excel-50 px-3 py-1 text-sm font-bold text-excel-600">ক্লাস {toBn(i + 1)}</span>
              </div>
              <h3 className="mt-4 text-lg font-bold leading-snug text-slate-900">{c.title}</h3>
              <ul className="mt-4 space-y-2">
                {c.topics.map((topic) => (
                  <li key={topic} className="flex gap-2 text-slate-600">
                    <CheckIcon className="mt-1 h-4 w-4 shrink-0 text-excel-500" />
                    {topic}
                  </li>
                ))}
              </ul>
            </article>
          ))}

          {course.enrollmentOpen && (
            <article className="flex flex-col justify-between rounded-2xl bg-gradient-to-br from-word-600 to-excel-600 p-6 text-white shadow-lg">
              <div>
                <div className="text-4xl">🎯</div>
                <h3 className="mt-3 text-xl font-bold">
                  {course.price != null ? `সবকিছু মাত্র ${taka(course.price)}-এ` : 'সব ক্লাস লাইভ, হাতে-কলমে'}
                </h3>
                <p className="mt-2 text-white/85">প্রতিটি ক্লাসে লাইভ প্র্যাকটিস, প্রশ্নোত্তর আর বাড়ির কাজ।</p>
              </div>
              <a href="#enroll" className="mt-6 inline-flex items-center justify-center rounded-xl bg-white px-5 py-3 font-bold text-word-600 transition hover:bg-word-50">
                সিট বুক করুন
              </a>
            </article>
          )}
        </div>
      </div>
    </section>
  );
}
